import styled from 'styled-components';
import { Box, Image } from '@user-portal/wikr-components';

import { color } from 'theme/selectors';
import mediaQueries from 'theme/mediaQueries';

export const Container = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    padding: 32px 16px 144px;
    width: 100%;
    max-width: 1028px;

    ${mediaQueries.laptop} {
        padding: 32px 32px 104px;
    }

    ${mediaQueries.smallDesktop} {
        padding: 32px 0 104px;
    }
`;

export const DownloadWrapper = styled(Box)`
    max-width: 147px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -56%);
    z-index: 10000;
`;

export const ContentWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    padding: 60px 48px 48px;
    ${({ $borderRadius }) => $borderRadius && `border-radius: ${$borderRadius}px;`};
    ${({ $mb }) => $mb && `margin-bottom: ${$mb}px;`};
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]}`};

    ${mediaQueries.smallDesktop} {
        flex-direction: row;
        padding: 48px;
    }
`;

export const ButtonsWrapper = styled(Box)`
    display: flex;
    justify-content: center;
    gap: 24px;
`;

export const ImageWrapper = styled.div`
    position: relative;
    flex-shrink: 0;
    margin: 40px auto;
    max-height: 458px;

    ${mediaQueries.smallDesktop} {
        margin: 0;
    }
`;

export const DownloadBlock = styled.div`
    display: flex;
    flex-direction: column;

    ${mediaQueries.smallDesktop} {
        display: none;
    }
`;

export const InstructionDownloadBlock = styled.div`
    display: none;

    ${mediaQueries.smallDesktop} {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const Line = styled.div`
    height: 1px;
    width: 126px;
    background-color: ${color('border-default')};
    margin: 16px 0 40px;
`;

export const ScanQrCodeWrapper = styled(Box)`
    width: 147px;
    height: 147px;
    padding-top: 0;
    position: relative;
    display: flex;
`;

export const QRWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;

    svg {
        transform: translate(-6px, -6px);
    }

    canvas {
        width: 100% !important;
        height: 100% !important;
    }
`;

export const InstructionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 24px;

    ${mediaQueries.smallDesktop} {
        padding-top: 12px;
    }
`;

export const InstructionContainer = styled(Box)`
    display: flex;

    ${mediaQueries.laptop} {
        align-items: center;
    }
`;

export const InstructionNumberContainer = styled.div`
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 16px;

    ${mediaQueries.laptop} {
        width: 32px;
        height: 32px;
    }
`;

export const InstructionNumber = styled.div`
    width: 28px;
    height: 28px;
    background-color: ${color('primary-default')};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    ${mediaQueries.laptop} {
        width: 32px;
        height: 32px;
    }
`;

export const Link = styled.button`
    max-width: fit-content;
    cursor: pointer;
`;

export const FrontChatButton = styled.button`
    border-bottom: 1px solid ${color('text-secondary')};
    color: ${color('text-secondary')};
    cursor: pointer;
`;

export const Instruction = styled.div`
    display: flex;
    flex-direction: column;
    overflow-wrap: break-word;
    word-break: break-word;
`;

export const HelpBox = styled(Box)`
    display: flex;
    gap: 16px;
    width: 100%;
    max-width: 447px;
    margin: 0 auto 16px;
    ${({ $borderRadius }) => $borderRadius && `border-radius: ${$borderRadius}px;`};
    ${({ $paddingBottom }) => $paddingBottom && `padding-bottom: ${$paddingBottom}px;`};
    ${({ $paddingTop }) => $paddingTop && `padding-top: ${$paddingTop}px;`};
    ${({ $paddingX }) => $paddingX && `padding-left: ${$paddingX}px; padding-right: ${$paddingX}px;`};
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]}`};

    ${mediaQueries.laptop} {
        margin: 0 auto 32px;
    }

    ${mediaQueries.smallDesktop} {
        max-width: 480px;
    }
`;

export const IconBox = styled.div`
    flex-shrink: 0;
`;

export const Footer = styled(Box)`
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    ${({ $paddingBottom }) => $paddingBottom && `padding-bottom: ${$paddingBottom}px;`};
`;

export const Arrow = styled(Image)`
    position: absolute;
    top: 181px;
    left: -104px;

    ${mediaQueries.smallDesktop} {
        top: 94px;
        left: -93px;
    }
`;

export const LargeText = styled.span`
    font-size: 18px;
    line-height: 28px;
    font-weight: bold;
`;

export const ArrowContainer = styled.div`
    position: absolute;
    top: 181px;
    left: -104px;

    ${mediaQueries.smallDesktop} {
        top: 94px;
        left: -93px;
    }
`;
